import { render, staticRenderFns } from "./menuTrabajoSocial.vue?vue&type=template&id=46cc2d7c&scoped=true"
import script from "./menuTrabajoSocial.vue?vue&type=script&lang=js"
export * from "./menuTrabajoSocial.vue?vue&type=script&lang=js"
import style0 from "./menuTrabajoSocial.vue?vue&type=style&index=0&id=46cc2d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc2d7c",
  null
  
)

export default component.exports